export default "__VITE_ASSET__DPIrDIO4__"